var ENC = {};
ENC._token = $.jStorage.get("localToken");
ENC.entrustment_data = {};

ENC.init = function() {
  ENC.inputsrequired();
  ENC.eventListener();
};

ENC.powerCert = (cert_api) => {
  let getRequest = new Promise((resolve, reject) => {
    $.ajax({
      url: `${v1url}${cert_api}`,
      type: "POST",
      data: {
        project_name: $("#project_name").val()
      },
      headers: {
        devicetoken: cookie_PENCILNEWSID,
        token: ENC._token
      },
      dataType: "json",
      success: (data) =>  {
        if (data.code == 1000) {
          resolve(data.data);
        } else {
          toastr.error(data.message);
        }
      },
      error: (err) => {
        console.log(err);
        reject(err);
      }
    });
  });
  return getRequest;
}

ENC.getCommittalTimes = () => {
  ENC.entrustment_data.project_name = $("#project_name").val();
    ENC.entrustment_data.company_name = $("#company_name").val();
    ENC.entrustment_data.industry = $("#industry").val();
    ENC.entrustment_data.other_information = $("#other_information").val();
    if (ENC.entrustment_data.project_name.length == 0) {
      return showWarning("请填写项目名称！");
    }
    ENC.committal_times = 0;
    $.ajax({
      url: v1url + "committal/get-committal-times",
      type: "GET",
      headers: {
        token: ENC._token
      },
      success: function(data) {
        if (data.code == -1) {
          reLoginOnUc();
          return;
        }
        if (data.code === 1000) {
          ENC.committal_times = data.data.committal_times;
          $("#entrustment_modal .footer-title .start").html(
            ENC.committal_times
          );
          $("#entrustment_modal").modal("show");
        } else {
          $("#entrustment_modal").modal("hide");
          showWarning(data.message);
        }
      }
  });
}

ENC.inputsrequired = function() {
  $("#entrustment_modal #btn-lf").on("click", function() {
    $("#entrustment_modal").modal("hide");
  });
  $("#confirm_modal #comfirm-btn").on("click", function() {
    $("#confirm_modal").modal("hide");
  });
  $("#entrustment-btn").on("click", function() {
    // alert("lalala!");
    ENC.powerCert('project/prev-name-committal').then((data) => {
      $(".js-pre-add-commit-contact .modal-body p").html(data.message);
      $(".js-pre-add-commit-contact .modal-footer .footer-title").html(data.prompt);
      $(".js-pre-add-commit-contact .modal-footer .comfirm-btn .btn-rt").attr("data-type", data.type);
      console.log(data.type);
      switch (data.type) {
        case 0:
        ENC.getCommittalTimes();
          break;
        case 1:
          $(".js-pre-add-commit-contact .modal-footer .comfirm-btn .btn-rt").html('<a href="/datacert">前往认证</a>');
          $(".js-pre-add-commit-contact").modal("show");
          break;
        case 4:
          $(".js-pre-add-commit-contact .modal-footer .comfirm-btn .btn-rt").html('确认');
          $(".js-pre-add-commit-contact").modal("show");
          break;
        default:
          break;
      }
    })
    
  });
  $(".js-pre-add-commit-contact .modal-footer .comfirm-btn .btn-rt").on('click', function(e) {
    let dataType = $(this).attr("data-type");
    console.log(dataType);
    if(dataType == 4){
      ENC.getCommittalTimes();
    }
    $(".js-pre-add-commit-contact").modal("hide");
  });
  $(".js-pre-add-commit-contact .modal-footer .comfirm-btn .btn-lf").on('click', function(e) {
    $(".js-pre-add-commit-contact").modal("hide");
  });

  $("#entrustment_modal #btn-rt").on("click", function() {
    $.ajax({
      url: v1url + "committal/project",
      type: "POST",
      headers: {
        token: ENC._token,
        devicetoken: cookie_PENCILNEWSID
      },
      data: ENC.entrustment_data,
      success: function(data) {
        if (data.code == -1) {
          reLoginOnUc();
          return;
        }
        if (data.code === 1000) {
          $("#entrustment_modal").modal("hide");
          $("#confirm_modal .footer-title .end").html(ENC.committal_times - 1);
          $("#confirm_modal").modal("show");
        } else {
          $("#entrustment_modal").modal("hide");
          showWarning(data.message);
        }
      }
    });
  });
};

ENC.eventListener = function() {
  $("#comfirm-btn").on("click", function() {
    ENC.handleJumpTo("consignation");
  });
  $("#jumpConsignation").on("click", function() {
    ENC.handleJumpTo("consignation");
  });
};

ENC.handleJumpTo = function(des) {
  if (des === "consignation") {
    $("#consignationDisplay").removeClass("be-hide");
    $("#projects-list").addClass("be-hide");
    $("#entrustmentDisplay").addClass("be-hide");
    setTimeout(function() {
      $("#tabs .tab")
        .eq(0)
        .click();
    }, 0);
  } else if (des === "entrustment") {
    $("#consignationDisplay").addClass("be-hide");
    $("#projects-list,#filter-box").addClass("be-hide");
    $("#entrustmentDisplay").removeClass("be-hide");
  } else if (des === "projectlist") {
    $("#consignationDisplay").addClass("be-hide");
    $("#entrustmentDisplay").addClass("be-hide");
    $("#projects-list,#filter-box").removeClass("be-hide");
  }
};
